import React from "react";
import { formatPrice } from "../../../utils/common";
import { handleContactUs } from "../../../utils/activityHelper";
import { ADD_ON_PURCHASE_MESSAGES as messages } from "./messages";
import { CONTACT_US, FIRST_PURCHASE, PREVIEW } from "./types";
import type { AddOnPurchaseProduct, LoginState } from "./types";
import "./addOnPurchase.scss";

export interface AddOnPurchasePriceProps {
  product: AddOnPurchaseProduct;
  loginState: LoginState;
  placeholder?: "cartItem";
}
const AddOnPurchasePriceWidget: React.FC<AddOnPurchasePriceProps> = ({ product, loginState, placeholder }) => {
  const isFirstPurchase = product.purchaseType === FIRST_PURCHASE;
  const hasPrice = product.finalPrice !== null && product.finalPrice !== undefined && product.finalPrice !== "";
  const contactUs = product.priceStatus === CONTACT_US || !hasPrice;
  const isPreview = product.priceStatus === PREVIEW;
  const colorClass = isFirstPurchase ? "firstPurchase" : "";
  const isCartItem = placeholder === "cartItem";
  const priceLabel = (
    <span className={`addOnPurchaseLabel ${colorClass}`}>
      {isFirstPurchase ? messages.firstPurchase : messages.repurchase}
    </span>
  );
  return (
    <div className="priceWrapper addOnPurchasePrice">
      {Number(product.listPrice) > 0 && (
        <span className="priceItem lightText lineThrough">{formatPrice(product.listPrice ?? undefined)}</span>
      )}
      {contactUs ? (
        <span className="textLink" onClick={() => handleContactUs(loginState)}>{messages.contactUs}</span>
      ) : isPreview ? (
        <span className="lightText">{formatPrice(product.finalPrice ?? undefined)}</span>
      ) : (
        <>
          {!isCartItem && priceLabel}
          <span className={`primaryText priceItem ${colorClass}`}>
            {isCartItem && priceLabel}
            {isCartItem ? (
              <span className="addOnPurchaseAmount">{formatPrice(product.finalPrice ?? undefined)}</span>
            ) : formatPrice(product.finalPrice ?? undefined)}
          </span>
        </>
      )}
      {product.limitQty != null && (
        <span className="addOnPurchaseLimit">{messages.limitQuantity(product.limitQty)}</span>
      )}
    </div>
  );
};
export default AddOnPurchasePriceWidget;
